 	// install a JSONP callback for chunk loading
 	function webpackJsonpCallback(data) {
 		var chunkIds = data[0];
 		var moreModules = data[1];
 		var executeModules = data[2];

 		// add "moreModules" to the modules object,
 		// then flag all "chunkIds" as loaded and fire callback
 		var moduleId, chunkId, i = 0, resolves = [];
 		for(;i < chunkIds.length; i++) {
 			chunkId = chunkIds[i];
 			if(Object.prototype.hasOwnProperty.call(installedChunks, chunkId) && installedChunks[chunkId]) {
 				resolves.push(installedChunks[chunkId][0]);
 			}
 			installedChunks[chunkId] = 0;
 		}
 		for(moduleId in moreModules) {
 			if(Object.prototype.hasOwnProperty.call(moreModules, moduleId)) {
 				modules[moduleId] = moreModules[moduleId];
 			}
 		}
 		if(parentJsonpFunction) parentJsonpFunction(data);

 		while(resolves.length) {
 			resolves.shift()();
 		}

 		// add entry modules from loaded chunk to deferred list
 		deferredModules.push.apply(deferredModules, executeModules || []);

 		// run deferred modules when all chunks ready
 		return checkDeferredModules();
 	};
 	function checkDeferredModules() {
 		var result;
 		for(var i = 0; i < deferredModules.length; i++) {
 			var deferredModule = deferredModules[i];
 			var fulfilled = true;
 			for(var j = 1; j < deferredModule.length; j++) {
 				var depId = deferredModule[j];
 				if(installedChunks[depId] !== 0) fulfilled = false;
 			}
 			if(fulfilled) {
 				deferredModules.splice(i--, 1);
 				result = __webpack_require__(__webpack_require__.s = deferredModule[0]);
 			}
 		}

 		return result;
 	}

 	// The module cache
 	var installedModules = {};

 	// object to store loaded and loading chunks
 	// undefined = chunk not loaded, null = chunk preloaded/prefetched
 	// Promise = chunk loading, 0 = chunk loaded
 	var installedChunks = {
 		"runtime": 0
 	};

 	var deferredModules = [];

 	// script path function
 	function jsonpScriptSrc(chunkId) {
 		return __webpack_require__.p + "" + ({"common":"common","dash-calendar-calendar-module":"dash-calendar-calendar-module","dash-my-schedule-my-schedule-module":"dash-my-schedule-my-schedule-module","dash-teacher-student-teacher-student-module":"dash-teacher-student-teacher-student-module","dash-users-profile-profile-module":"dash-users-profile-profile-module","components-dashboard-conference-represent-student-conference-represent-student-module":"components-dashboard-conference-represent-student-conference-represent-student-module","components-dashboard-contenidostudent-contenidostudent-module":"components-dashboard-contenidostudent-contenidostudent-module","components-dashboard-library-library-module":"components-dashboard-library-library-module","components-dashboard-managersum-managersum-module":"components-dashboard-managersum-managersum-module","components-dashboard-repo-repo-module":"components-dashboard-repo-repo-module","dash-admin-admin-module":"dash-admin-admin-module","dash-administration-direction-direction-module":"dash-administration-direction-direction-module","dash-config-student-config-student-module":"dash-config-student-config-student-module","dash-school-school-module":"dash-school-school-module","dash-subjects-subjects-module":"dash-subjects-subjects-module","dash-teacher-teacher-module":"dash-teacher-teacher-module","default~activities-activities-module~classe-classe-module~components-dashboard-fathers-fathers-modul~8ed80b81":"default~activities-activities-module~classe-classe-module~components-dashboard-fathers-fathers-modul~8ed80b81","dash-notification-notification-module":"dash-notification-notification-module","default~activities-activities-module~components-dashboard-detallecontenidostudent-detallecontenidost~5daedc13":"default~activities-activities-module~components-dashboard-detallecontenidostudent-detallecontenidost~5daedc13","components-dashboard-detallecontenidostudent-detallecontenidostudent-module":"components-dashboard-detallecontenidostudent-detallecontenidostudent-module","dash-myrealeases-myrealeases-module":"dash-myrealeases-myrealeases-module","default~activities-activities-module~components-dashboard-makecontenidostudent-makecontenidostudent-~5a53e379":"default~activities-activities-module~components-dashboard-makecontenidostudent-makecontenidostudent-~5a53e379","default~activities-activities-module~components-dashboard-makecontenidostudent-makecontenidostudent-~f28a63de":"default~activities-activities-module~components-dashboard-makecontenidostudent-makecontenidostudent-~f28a63de","default~activities-activities-module~components-dashboard-makecontenidostudent-makecontenidostudent-~0c08d88f":"default~activities-activities-module~components-dashboard-makecontenidostudent-makecontenidostudent-~0c08d88f","default~activities-activities-module~components-dashboard-makecontenidostudent-makecontenidostudent-~f49e66d7":"default~activities-activities-module~components-dashboard-makecontenidostudent-makecontenidostudent-~f49e66d7","default~activities-activities-module~components-dashboard-makecontenidostudent-makecontenidostudent-~0ad5861e":"default~activities-activities-module~components-dashboard-makecontenidostudent-makecontenidostudent-~0ad5861e","default~activities-activities-module~components-dashboard-makecontenidostudent-makecontenidostudent-~36f58285":"default~activities-activities-module~components-dashboard-makecontenidostudent-makecontenidostudent-~36f58285","dash-releases-releases-module":"dash-releases-releases-module","default~activities-activities-module~classe-classe-module~components-dashboard-makecontenidostudent-~bd706f9e":"default~activities-activities-module~classe-classe-module~components-dashboard-makecontenidostudent-~bd706f9e","default~activities-activities-module~classe-classe-module~components-dashboard-makecontenidostudent-~c1d5dfbe":"default~activities-activities-module~classe-classe-module~components-dashboard-makecontenidostudent-~c1d5dfbe","components-dashboard-makecontenidostudent-makecontenidostudent-module":"components-dashboard-makecontenidostudent-makecontenidostudent-module","default~classes-classes-module~components-dashboard-fathers-fathers-module~content-content-module~da~93282ef8":"default~classes-classes-module~components-dashboard-fathers-fathers-module~content-content-module~da~93282ef8","default~classes-classes-module~content-content-module~dash-home-home-module~dash-sum-sum-module~foru~d3b360a9":"default~classes-classes-module~content-content-module~dash-home-home-module~dash-sum-sum-module~foru~d3b360a9","dash-sum-sum-module":"dash-sum-sum-module","default~activities-activities-module~classes-classes-module~components-dashboard-fathers-fathers-mod~c167cd09":"default~activities-activities-module~classes-classes-module~components-dashboard-fathers-fathers-mod~c167cd09","default~classes-classes-module~components-dashboard-fathers-fathers-module~dash-administration-modul~be127967":"default~classes-classes-module~components-dashboard-fathers-fathers-module~dash-administration-modul~be127967","default~classes-classes-module~components-dashboard-fathers-fathers-module~dash-ratingscenter-rating~620134f3":"default~classes-classes-module~components-dashboard-fathers-fathers-module~dash-ratingscenter-rating~620134f3","components-dashboard-fathers-fathers-module":"components-dashboard-fathers-fathers-module","dash-mixed-groups-mixed-groups-module":"dash-mixed-groups-mixed-groups-module","default~classes-classes-module~dash-home-home-module~dash-ratingscenter-ratingscenter-module":"default~classes-classes-module~dash-home-home-module~dash-ratingscenter-ratingscenter-module","default~dash-home-home-module~dash-ratingscenter-ratingscenter-module":"default~dash-home-home-module~dash-ratingscenter-ratingscenter-module","default~dash-attendance-management-attendance-management-module~dash-ratingscenter-ratingscenter-module":"default~dash-attendance-management-attendance-management-module~dash-ratingscenter-ratingscenter-module","dash-ratingscenter-ratingscenter-module":"dash-ratingscenter-ratingscenter-module","default~dash-users-users-module~schools-schools-list-schools-list-module":"default~dash-users-users-module~schools-schools-list-schools-list-module","default~dash-users-users-module~schools-users-schools-users-module":"default~dash-users-users-module~schools-users-schools-users-module","default~dash-administration-module~dash-home-home-module":"default~dash-administration-module~dash-home-home-module","dash-administration-module":"dash-administration-module","dash-attendance-management-attendance-management-module":"dash-attendance-management-attendance-management-module","dash-home-home-module":"dash-home-home-module","firebase-auth":"firebase-auth","sha-not-found-not-found-module":"sha-not-found-not-found-module","default~detail-detail-module~subjects-activities-detail-detail-module":"default~detail-detail-module~subjects-activities-detail-detail-module","subjects-activities-detail-detail-module":"subjects-activities-detail-detail-module","conference-represent-student-conference-represent-student-director-conference-represent-student-director-module":"conference-represent-student-conference-represent-student-director-conference-represent-student-director-module","conference-represent-student-conference-represent-student-teacher-conference-represent-student-teacher-module":"conference-represent-student-conference-represent-student-teacher-conference-represent-student-teacher-module","view-content-view-content-module":"view-content-view-content-module","dash-makesum-makesum-module":"dash-makesum-makesum-module","eventssum-eventssum-module":"eventssum-eventssum-module","default~makeactivity-makeactivity-module~makecomu-makecomu-module~makecontent-makecontent-module":"default~makeactivity-makeactivity-module~makecomu-makecomu-module~makecontent-makecontent-module","makeactivity-makeactivity-module":"makeactivity-makeactivity-module","makecontent-makecontent-module":"makecontent-makecontent-module","makecomu-makecomu-module":"makecomu-makecomu-module","schools-schools-list-schools-list-module":"schools-schools-list-schools-list-module","licenses-licenses-module":"licenses-licenses-module","activities-activities-module":"activities-activities-module","presentation-presentation-module":"presentation-presentation-module","default~content-content-module~teacher-content-content-module":"default~content-content-module~teacher-content-content-module","content-content-module":"content-content-module","default~classes-classes-module~live-live-module":"default~classes-classes-module~live-live-module","live-live-module":"live-live-module","classes-classes-module":"classes-classes-module","forum-forum-module":"forum-forum-module","teacher-teacher-module":"teacher-teacher-module","classe-classe-module":"classe-classe-module","default~detail-detail-module~forum-forum-discussion-forum-discussion-module~forum-forum-teacher-deta~4c68c15f":"default~detail-detail-module~forum-forum-discussion-forum-discussion-module~forum-forum-teacher-deta~4c68c15f","default~detail-detail-module~forum-forum-teacher-detail-detail-module":"default~detail-detail-module~forum-forum-teacher-detail-detail-module","forum-forum-teacher-detail-detail-module":"forum-forum-teacher-detail-detail-module","forum-forum-discussion-forum-discussion-module":"forum-forum-discussion-forum-discussion-module","forum-forum-teacher-forum-teacher-module":"forum-forum-teacher-forum-teacher-module","canvg":"canvg","dompurify":"dompurify","schools-users-schools-users-module":"schools-users-schools-users-module","detail-detail-module":"detail-detail-module","evaluations-evaluations-module":"evaluations-evaluations-module"}[chunkId]||chunkId) + ".js"
 	}

 	// The require function
 	function __webpack_require__(moduleId) {

 		// Check if module is in cache
 		if(installedModules[moduleId]) {
 			return installedModules[moduleId].exports;
 		}
 		// Create a new module (and put it into the cache)
 		var module = installedModules[moduleId] = {
 			i: moduleId,
 			l: false,
 			exports: {}
 		};

 		// Execute the module function
 		modules[moduleId].call(module.exports, module, module.exports, __webpack_require__);

 		// Flag the module as loaded
 		module.l = true;

 		// Return the exports of the module
 		return module.exports;
 	}

 	// This file contains only the entry chunk.
 	// The chunk loading function for additional chunks
 	__webpack_require__.e = function requireEnsure(chunkId) {
 		var promises = [];


 		// JSONP chunk loading for javascript

 		var installedChunkData = installedChunks[chunkId];
 		if(installedChunkData !== 0) { // 0 means "already installed".

 			// a Promise means "currently loading".
 			if(installedChunkData) {
 				promises.push(installedChunkData[2]);
 			} else {
 				// setup Promise in chunk cache
 				var promise = new Promise(function(resolve, reject) {
 					installedChunkData = installedChunks[chunkId] = [resolve, reject];
 				});
 				promises.push(installedChunkData[2] = promise);

 				// start chunk loading
 				var script = document.createElement('script');
 				var onScriptComplete;

 				script.charset = 'utf-8';
 				script.timeout = 120;
 				if (__webpack_require__.nc) {
 					script.setAttribute("nonce", __webpack_require__.nc);
 				}
 				script.src = jsonpScriptSrc(chunkId);

 				// create error before stack unwound to get useful stacktrace later
 				var error = new Error();
 				onScriptComplete = function (event) {
 					// avoid mem leaks in IE.
 					script.onerror = script.onload = null;
 					clearTimeout(timeout);
 					var chunk = installedChunks[chunkId];
 					if(chunk !== 0) {
 						if(chunk) {
 							var errorType = event && (event.type === 'load' ? 'missing' : event.type);
 							var realSrc = event && event.target && event.target.src;
 							error.message = 'Loading chunk ' + chunkId + ' failed.\n(' + errorType + ': ' + realSrc + ')';
 							error.name = 'ChunkLoadError';
 							error.type = errorType;
 							error.request = realSrc;
 							chunk[1](error);
 						}
 						installedChunks[chunkId] = undefined;
 					}
 				};
 				var timeout = setTimeout(function(){
 					onScriptComplete({ type: 'timeout', target: script });
 				}, 120000);
 				script.onerror = script.onload = onScriptComplete;
 				document.head.appendChild(script);
 			}
 		}
 		return Promise.all(promises);
 	};

 	// expose the modules object (__webpack_modules__)
 	__webpack_require__.m = modules;

 	// expose the module cache
 	__webpack_require__.c = installedModules;

 	// define getter function for harmony exports
 	__webpack_require__.d = function(exports, name, getter) {
 		if(!__webpack_require__.o(exports, name)) {
 			Object.defineProperty(exports, name, { enumerable: true, get: getter });
 		}
 	};

 	// define __esModule on exports
 	__webpack_require__.r = function(exports) {
 		if(typeof Symbol !== 'undefined' && Symbol.toStringTag) {
 			Object.defineProperty(exports, Symbol.toStringTag, { value: 'Module' });
 		}
 		Object.defineProperty(exports, '__esModule', { value: true });
 	};

 	// create a fake namespace object
 	// mode & 1: value is a module id, require it
 	// mode & 2: merge all properties of value into the ns
 	// mode & 4: return value when already ns object
 	// mode & 8|1: behave like require
 	__webpack_require__.t = function(value, mode) {
 		if(mode & 1) value = __webpack_require__(value);
 		if(mode & 8) return value;
 		if((mode & 4) && typeof value === 'object' && value && value.__esModule) return value;
 		var ns = Object.create(null);
 		__webpack_require__.r(ns);
 		Object.defineProperty(ns, 'default', { enumerable: true, value: value });
 		if(mode & 2 && typeof value != 'string') for(var key in value) __webpack_require__.d(ns, key, function(key) { return value[key]; }.bind(null, key));
 		return ns;
 	};

 	// getDefaultExport function for compatibility with non-harmony modules
 	__webpack_require__.n = function(module) {
 		var getter = module && module.__esModule ?
 			function getDefault() { return module['default']; } :
 			function getModuleExports() { return module; };
 		__webpack_require__.d(getter, 'a', getter);
 		return getter;
 	};

 	// Object.prototype.hasOwnProperty.call
 	__webpack_require__.o = function(object, property) { return Object.prototype.hasOwnProperty.call(object, property); };

 	// __webpack_public_path__
 	__webpack_require__.p = "";

 	// on error function for async loading
 	__webpack_require__.oe = function(err) { console.error(err); throw err; };

 	var jsonpArray = window["webpackJsonp"] = window["webpackJsonp"] || [];
 	var oldJsonpFunction = jsonpArray.push.bind(jsonpArray);
 	jsonpArray.push = webpackJsonpCallback;
 	jsonpArray = jsonpArray.slice();
 	for(var i = 0; i < jsonpArray.length; i++) webpackJsonpCallback(jsonpArray[i]);
 	var parentJsonpFunction = oldJsonpFunction;


 	// run deferred modules from other chunks
 	checkDeferredModules();
